import { OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Application } from 'app/shared/services/app/application/application.model';
import { InlineSpinnerLoaderComponent } from 'app/shared/components/inline-spinner-loader/inline-spinner-loader.component';
import { Session } from 'app/shared/services/session/session.service';
import { ApplicationService } from 'app/shared/services/app/application/application.service';
import { RoleType } from 'app/shared/services/user/user-application-properties.model';
import { Router } from '@angular/router';
import { ActiveUser } from '../shared/services/user/active-user.model';
import { GlobalRole } from 'app/shared/services/user/base-user.model';

export abstract class TogglitScreen implements OnInit, OnDestroy {
  app: Application;
  user: ActiveUser;
  subscriptions: any[] = [];
  @ViewChild('previewSpinner') previewSpinner: InlineSpinnerLoaderComponent;
  @ViewChild('containerSpinner') containerSpinner: InlineSpinnerLoaderComponent;

  protected abstract _session: Session;
  protected abstract _appService: ApplicationService;
  protected abstract _router: Router;

  constructor() {}

  ngOnInit() {
    if (this.previewSpinner && !this.previewSpinner.isActive) { this.previewSpinner.show(); }
    if (this.containerSpinner && !this.containerSpinner.isActive) { this.containerSpinner.show(); }
    this._session.user()
      .then((user) => {
        this.user = user;
        return this._appService.getApplicationDetails(this._session.selectedAppSysName);
      })
    .then((app: Application) => {
      this.app = app;
      if (!this.checkPermissions()) this._router.navigateByUrl('');
      this.afterInit();
    });
  }

  checkPermissions() {
    if (this.user.globalRole.level == GlobalRole.SuperAdmin) return true;
    let currentRoute = this._router.url;

    if (currentRoute.split('/')[1] == 'app') {
      if (!this.app.isActive) return false;

      if (currentRoute.split('/')[3] == 'features') {
        let currentFeature = currentRoute.split('/')[4];

        // for these, the route name is not the same as the system feature name...
        if (currentFeature == 'home-screen') currentFeature = 'pods';
        if (currentFeature == 'promotions') currentFeature = 'ads';

        // because users can still see the app content index even if they can't edit
        if (currentFeature == 'pages') {
          if (!this.user.hasFeaturePermission(this.app.sys_name, currentFeature) &&
              (currentRoute.includes('create') ||
              currentRoute.includes('edit'))) {
                return false;
              }
          return true;
        }

        if (currentFeature == 'calendar') currentFeature = 'events';

        return this.user.hasFeaturePermission(this.app.sys_name, currentFeature);

      } else if (currentRoute.split('/')[3] == 'users') { // also handles students pages
        let localRole = this.user.roles.filter(role => role.application.sys_name == this.app.sys_name)[0].level;
        return localRole >= RoleType.Owner;

      } else if (currentRoute.includes('settings')) {
        return this.user.globalRole.level >= GlobalRole.Admin;
      }
    } else if (currentRoute.includes('/account_settings')) {
      return true;

    } else if (currentRoute.includes('/users')) {
      return false;

    } else if (currentRoute.includes('apps/create')) {
      return this.user.canCreateApps;

    }
    return false;
  }

  abstract afterInit();
  afterDestroy() {};

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    if (this.previewSpinner && this.previewSpinner.isActive) { this.previewSpinner.hide(); }
    if (this.containerSpinner && this.containerSpinner.isActive) { this.containerSpinner.hide(); }
    this.afterDestroy();
  }
}



// WEBPACK FOOTER //
// /app/src/app/screens/togglit-screen.ts